'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _webComponents = require('@vezeeta/web-components');

var _assistant = require('../actions/assistant');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*:: type State = {
  getAssistants: {
    assistants: Function,
    assistantsList: Map<String, Object>,
  },
  addAssistanthModal: {
    show: boolean,
  },
  assistantState: {
    isSaving: boolean,
  },
  addAssistant: {
    isSaving: boolean,
    addAssistantState: String,
    errorMessage: String,
  },
};*/


var initialState = {
  getAssistants: {
    assistants: _webComponents.renderer.loading(),
    assistantsList: new Map()
  },
  addAssistanthModal: {
    show: false
  },
  assistantState: {
    isSaving: false
  },
  addAssistant: {
    isSaving: false,
    addAssistantState: undefined,
    errorMessage: undefined
  }
};

exports.default = function () {
  var state /*: State*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _assistant.ASSISTANT.FETCH_ASSISTANTS.LOAD:
      {
        return _extends({}, state, {
          getAssistants: {
            assistants: _webComponents.renderer.loading(),
            assistantsList: new Map()
          }
        });
      }
    case _assistant.ASSISTANT.FETCH_ASSISTANTS.SUCCESS:
      {
        return _extends({}, state, {
          getAssistants: {
            assistants: _webComponents.renderer.success(payload.assistants),
            assistantsList: payload.assistants
          }
        });
      }
    case _assistant.ASSISTANT.FETCH_ASSISTANTS.FAIL:
      {
        return _extends({}, state, {
          getAssistants: {
            assistants: _webComponents.renderer.failure()
          }
        });
      }
    case _assistant.ASSISTANT.ADD_ASSISTANT.LOAD:
      {
        return _extends({}, state, {
          addAssistant: {
            isSaving: true,
            addAssistantState: _assistant.ASSISTANT.ADD_ASSISTANT.LOAD
          }
        });
      }
    case _assistant.ASSISTANT.ADD_ASSISTANT.SUCCESS:
      {
        return _extends({}, state, {
          addAssistanthModal: {
            show: false
          },
          addAssistant: {
            isSaving: false,
            addAssistantState: _assistant.ASSISTANT.ADD_ASSISTANT.SUCCESS
          }
        });
      }
    case _assistant.ASSISTANT.ADD_ASSISTANT.FAIL:
      {
        return _extends({}, state, {
          addAssistant: {
            isSaving: false,
            errorMessage: payload.errorMessage,
            addAssistantState: _assistant.ASSISTANT.ADD_ASSISTANT.FAIL
          }
        });
      }
    case _assistant.ASSISTANT.ASSISTANT_STATE.LOAD:
      {
        return _extends({}, state, {
          assistantState: {
            isSaving: true
          }
        });
      }
    case _assistant.ASSISTANT.ASSISTANT_STATE.SUCCESS:
      {
        return _extends({}, state, {
          assistantState: {
            isSaving: false
          }
        });
      }
    case _assistant.ASSISTANT.ASSISTANT_STATE.FAIL:
      {
        return _extends({}, state, {
          assistantState: {
            isSaving: false
          }
        });
      }
    case _assistant.ASSISTANT.MODAL.TOGGLE_ADD:
      {
        return _extends({}, state, {
          addAssistanthModal: {
            show: payload.showModel
          }
        });
      }
    default:
      return state;
  }
};

module.exports = exports['default'];